import debounce from 'lodash/debounce';
import { domain } from 'modules/data';
import { FC } from 'react';
import { useDispatch } from 'react-redux';

import { editRequestField } from '../../../actions';
import XeroAirwallexBatchPaymentFormContent from './components/XeroAirwallexBatchPaymentFormContent/XeroAirwallexBatchPaymentFormContent';
import { XeroAirwallexBatchPaymentFormContextProvider } from './XeroAirwallexBatchPaymentForm.context';

interface XeroAirwallexBatchPaymentFormProps {
    request: domain.XeroAirwallexBatchPaymentRequest;
}

const XeroAirwallexBatchPaymentForm: FC<XeroAirwallexBatchPaymentFormProps> = (props) => {
    const { request } = props;

    const dispatch = useDispatch();

    const debouncedEditRequestField = debounce(
        <TDetails, TKey extends keyof TDetails = keyof TDetails>(propName: TKey, newValue: TDetails[TKey]) => {
            dispatch(editRequestField<TDetails>(propName, newValue));
        },
        200
    );

    return (
        <XeroAirwallexBatchPaymentFormContextProvider request={request} editRequestField={debouncedEditRequestField}>
            <XeroAirwallexBatchPaymentFormContent request={request} />
        </XeroAirwallexBatchPaymentFormContextProvider>
    );
};

export default XeroAirwallexBatchPaymentForm;
